import { documentsFilters } from '@factorin/domain';
import { documents, signs } from '@factorin/rest';

import { PromptModal } from './components/PromptModal';
import translations from './translations.json';
import { fappSubscriptions } from './state';
import { ErrorBoundaryMiddleware } from './ErrorBoundaryMiddleware';


export * from './components';

export const fapp = {
    API: {
        domain: {
            documents,
            signs,
        },
    },

    messaging: {
        modalTypes: {
            PromptModal,
        },
    },

    data: {
        domain: {
            documents: {
                filters: documentsFilters,
            },
        },
    },

    environment: {
        initializationSagas: [],
    },

    wamp: {
        subscriptions: [
            ...fappSubscriptions,
        ],
    },

    translations,
    renderChain: [
        [ErrorBoundaryMiddleware, 100],
    ],
};
